<ion-content class="ion-padding">
    <br />
    <h3 class="ion-text-center" [innerHTML]="'ABORT_TITLE' | translate"></h3>
    <h6 class="ion-text-center ion-padding" [innerHTML]="'ABORT_MESSAGES.INCOMPATIBLE_APP_VERSION' | translate"></h6>
    <br />
</ion-content>
